**Drawdown** plots the return differences between the historical peak and the
current level of the index with reference to the time period analyzed.
